import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {PremiumCarousel} from './PremiumCarousel';
import {Card as FabricCard} from '~/common/canvas/Card/Card';
import {GrcCard} from '~/common/fabric/Card/components/AnimationPreview/components/GrcCard';
import './Premium.sass';

export const AnimationPreview = ({
  message,
  fabricArt,
  hideFlipButton,
  isWebview,
  initCardFlipped,
  recipientName,
}) => {
  const [replayOffsetWidth, setReplayOffsetWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const previewRef = useRef();
  const cardRef = useRef();

  useEffect(() => {
    setReplayOffsetWidth(cardRef?.current?.offsetWidth);
    setHeight(cardRef.current?.style?.height || cardRef?.current?.offsetHeight);
  }, [cardRef?.current?.offsetWidth]);

  const content = useMemo(
    () =>
      hideFlipButton ? (
        <div ref={cardRef}>
          <FabricCard fabricArt={fabricArt} imageRef={cardRef} />
        </div>
      ) : (
        <GrcCard yourInvitationRef={cardRef} message={message} fabricArt={fabricArt} />
      ),
    [hideFlipButton, message]
  );

  const animationStartCallback = useCallback(() => {
    if (!hideFlipButton) {
      cardRef.current?.firstChild?.classList.add('hidden-btn');
      cardRef.current?.setCardFlipped?.(false);
    }
  }, [initCardFlipped, hideFlipButton]);

  const animationEndCallback = useCallback(
    (isFirstRender) => {
      if (!hideFlipButton) {
        cardRef.current?.setCardFlipped?.(initCardFlipped && isFirstRender);
        cardRef.current?.firstChild?.classList.remove('hidden-btn');
      }
    },
    [initCardFlipped, hideFlipButton]
  );

  return (
    <div ref={previewRef} id="animation-preview" className="fabric-grc-animation-preview">
      <PremiumCarousel
        isWebview={!!isWebview}
        height={height}
        fabricArt={fabricArt}
        replayOffsetWidth={replayOffsetWidth}
        recipientName={recipientName}
        animationEndCallback={animationEndCallback}
        animationStartCallback={animationStartCallback}
      >
        {content}
      </PremiumCarousel>
    </div>
  );
};
